import React from 'react';
import { useResponsive } from '../../../hooks/useResponsive';

interface UserImageSectionProps {
  image: {
    data?: File;
    preview?: string;
  };
  setImage: React.Dispatch<React.SetStateAction<{
    data?: File;
    preview?: string;
  }>>;
  activeSection: string;
}

const UserImageSection: React.FC<UserImageSectionProps> = ({ image, setImage, activeSection }) => {
  const { isMobile } = useResponsive()
  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setImage({
        data: e.target.files[0],
        preview: URL.createObjectURL(e.target.files[0]),
      });
    }
  };

  return (
    <section className={`bottom ${isMobile && activeSection !== 'image' ? 'hidden-mobile' : ''}`}>
      <h6 className="dashBoardTitle">تصویر کاربر</h6>
      <div className={`image-section ${isMobile ? 'mobile-image-section' : 'AddInfoContainer'}`}>
        <div className="file-input-container">
          <input
            type="file"
            id="userImage"
            onChange={handleImageChange}
            accept="image/*"
            className="file-input"
          />
          <label htmlFor="userImage" className="file-input-label">
            انتخاب تصویر
          </label>
          <span className="file-info">حداکثر 5 مگابایت</span>
        </div>

        {image.preview && (
          <div className="image-preview-container">
            <img src={image.preview} className='user-image-preview' alt="عکس کاربر" />
            <button
              type="button"
              className="remove-image-btn"
              onClick={() => setImage({})}
            >
              حذف تصویر
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default UserImageSection;
